var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AccordionItemHeaderBase } from './AccordionItemHeaderBase';
import { AccordionItemPanelBase } from './AccordionItemPanelBase';
export const AccordionItemBase = (_a) => {
    var { heading, headingLevel, description, panel, className, isExpanded, disableContainer = false, onExpandedChange, accordionItemKey, dataTracking, ariaDescribedBy, onHeaderClick } = _a, rest = __rest(_a, ["heading", "headingLevel", "description", "panel", "className", "isExpanded", "disableContainer", "onExpandedChange", "accordionItemKey", "dataTracking", "ariaDescribedBy", "onHeaderClick"]);
    const ref = React.useRef(null);
    const onClosePanel = () => {
        var _a, _b;
        onExpandedChange(false);
        (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.focus();
    };
    return (React.createElement("div", { className: className },
        React.createElement(AccordionItemHeaderBase, Object.assign({ disableContainer: disableContainer, heading: heading, headingLevel: headingLevel, description: description, ref: ref, isExpanded: Boolean(isExpanded), onExpandedChange: onExpandedChange, accordionItemKey: accordionItemKey, dataTracking: dataTracking, ariaDescribedBy: ariaDescribedBy, onHeaderClick: onHeaderClick }, rest)),
        React.createElement(AccordionItemPanelBase, { panel: panel, closePanel: onClosePanel, isExpanded: Boolean(isExpanded), disableContainer: disableContainer })));
};
//# sourceMappingURL=AccordionItemBase.js.map